// scaffold a simple ActivityForm component
import { FC } from 'react';
import { Grid } from '@mui/material';

const ActivityNoteFields: FC = () => {
  return <Grid container spacing={2}></Grid>;
};

export default ActivityNoteFields;
